"use strict";

var DateField, Mixins, React, SingleInputMixin, StandardErrorDisplayMixin;

React = require("react");

Mixins = require("./mixins/Mixins");

SingleInputMixin = require("./mixins/SingleInput");

StandardErrorDisplayMixin = require("./mixins/StandardErrorDisplay");

DateField = React.createClass({
  displayName: "DateField",

  mixins: [SingleInputMixin, StandardErrorDisplayMixin],
  propTypes: {
    dataKey: React.PropTypes.string
  },
  onChange: function onChange(event) {
    return this.props.onDataChanged(this.props.dataKey, event.target.value);
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: this.errorClasses("form-group") },
      React.createElement(
        "label",
        { className: "col-sm-2 control-label", htmlFor: this.props.dataKey },
        this.props.displayName
      ),
      React.createElement(
        "div",
        { className: "col-sm-10" },
        React.createElement("input", {
          type: "date",
          className: "form-control",
          name: this.props.dataKey,
          value: this.props.data,
          onChange: this.onChange,
          placeholder: this.props.placeholder,
          title: this.props.title
        }),
        this.errorSpan()
      )
    );
  }
});

module.exports = DateField;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/Date.js
 ** module id = 336
 ** module chunks = 0
 **/